export const heroBadges = [
  '6 Volumes',
  '5 Bonuses',
  '200+ Sessions',
  '101 Drills',
  'All Age Groups',
]

export const heroStats = [
  { value: '+500', label: 'COACHES' },
  { value: '6+5', label: 'VOLUMES & BONUSES' },
  { value: '4.9/5', label: 'RATING ⭐' },
  { value: '🌍', label: 'WORLDWIDE' },
]

export const topReviews = [
  {
    quote:
      '"I planned my entire season in a single evening. Now every practice has a clear objective."',
    name: 'Sarah M.',
    location: 'Manchester, UK',
  },
  {
    quote:
      '"My players are improving so much faster now that they finally follow a logical progression."',
    name: 'Coach Emma',
    location: 'Auckland, NZ',
  },
  {
    quote:
      '"I no longer spend hours on YouTube hunting for drills. I open Netball Ready 360 and it is all there."',
    name: 'Lisa T.',
    location: 'Perth, Australia',
  },
]

export const problems = [
  'You arrive at the court without a real plan',
  'You spend hours preparing training before every session',
  'You keep searching for new drills online',
  'Skill levels in your group vary wildly',
  "You don't know how to structure a full season progression",
  'Sessions always feel improvised',
]

export const readyStats = [
  { icon: 'file', value: '180+', label: 'PAGES' },
  { icon: 'dumbbell', value: '200+', label: 'SESSIONS' },
  { icon: 'target', value: '101', label: 'DRILLS' },
  { icon: 'users', value: 'All', label: 'CATEGORIES' },
]

export const coverageTags = [
  'U10-U12',
  'U13-U15',
  'U16-U19/Senior',
  'Physical Conditioning',
  'Tactics',
  'Scouting',
]

export const volumes = [
  {
    dot: '🟢',
    label: 'VOLUME 1',
    title: 'Youth Netball U10-U12',
    highlight: '40 complete sessions',
    detail: 'Passing · Footwork · Position Basics · Coordination',
  },
  {
    dot: '🟡',
    label: 'VOLUME 2',
    title: 'Junior Netball U13-U15',
    highlight: '40 complete sessions',
    detail: 'Feeding Chain · Shooting & Defensive Pairs · Transitions',
  },
  {
    dot: '🟠',
    label: 'VOLUME 3',
    title: 'Advanced Netball U16-U19/Senior',
    highlight: '40 complete sessions',
    detail: 'Advanced Tactics · Defensive Systems · Game Management',
  },
  {
    dot: '🔴',
    label: 'VOLUME 4',
    title: 'Physical Conditioning Protocols',
    highlight: 'Specific training programs',
    detail: 'Speed · Agility · Landing Mechanics · Injury Prevention',
  },
  {
    dot: '🟣',
    label: 'VOLUME 5',
    title: '101 Shooting & Feeding Drills',
    highlight: 'All categories',
    detail: 'Classified by position and level',
  },
  {
    dot: '⭐',
    label: 'VOLUME 6',
    title: 'Scouting & Team Management',
    highlight: 'Advanced coaching tools',
    detail: 'Position-specific evaluations · Performance tracking · Communication',
  },
]

export const volumeIncludes = [
  'Annual Planning',
  'Complete Sessions',
  'Ready-to-use Diagrams',
  'Skill Progressions',
  'Sessions by Age Group',
  'Tracking Tools',
]

export const bonuses = [
  {
    number: 'BONUS 01',
    oldPrice: '$59',
    title: 'Full Season Planner',
    description: '12-month visual calendar + weekly planning sheets.',
    image: 'https://cdn.magicpatterns.com/uploads/iaM7aS5XF9u4Ah3hLUtzrS/n1.webp',
    imageAlt: 'Full Season Planner book cover',
  },
  {
    number: 'BONUS 02',
    oldPrice: '$64',
    title: '30 Practice Session Templates',
    description: 'Ready-to-use blank session sheets with court diagrams.',
    image: 'https://cdn.magicpatterns.com/uploads/svvnZyrNNHSiR3jSf5GZWD/n2.webp',
    imageAlt: 'Practice Session Templates book cover',
  },
  {
    number: 'BONUS 03',
    oldPrice: '$79',
    title: 'Tactical Playbook — 30 Set Plays',
    description: 'Complete plays with diagrams — offense, defense and special situations.',
    image: 'https://cdn.magicpatterns.com/uploads/vq2cjauWpPg1TNZautp4sU/n3.webp',
    imageAlt: 'Tactical Playbook book cover',
  },
  {
    number: 'BONUS 04',
    oldPrice: '$64',
    title: 'Player Evaluation System',
    description: 'Complete assessment toolkit with forms, trackers and parent reports.',
    image: 'https://cdn.magicpatterns.com/uploads/k9PxvHayC3VgEWHFSMZcGy/n4.webp',
    imageAlt: 'Player Evaluation System book cover',
  },
  {
    number: 'BONUS 05',
    oldPrice: '$72',
    title: 'Warm-Up & Activation Bible',
    description: 'Warm-up and cool-down routines for all ages and situations.',
    image: 'https://cdn.magicpatterns.com/uploads/fYm4dDA8pBd1vFHd7B87Nb/n5.webp',
    imageAlt: 'Warm-Up & Activation Bible book cover',
  },
]

export const pricingIncludes = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  '101 Professional Drills',
  'Over 180 Pages',
  'Lifetime Access',
]

export const playbookFeatures = [
  {
    title: 'Advanced set plays diagrams',
    description: 'Full-court diagrams for the time-out.',
  },
  {
    title: 'Professional movement patterns',
    description: 'Ready-made plays for every game situation.',
  },
  {
    title: 'Game-day cheat sheets',
    description: 'Silent communication with your team.',
  },
  {
    title: 'Video scouting guide',
    description: 'Analyze your opponent from your phone in minutes.',
  },
  {
    title: 'Individual breakdowns',
    description: 'History, metrics and personal goals.',
  },
  {
    title: 'Advanced match reports',
    description: 'Documents ready to hand over.',
  },
]

export const testimonials = [
  {
    initials: 'CS',
    quote:
      '"I mapped out my whole season in one night. Every single practice now has a clear goal, and I walk in knowing exactly what we are doing."',
    name: 'Chloe S.',
    location: 'London, UK',
  },
  {
    initials: 'MR',
    quote:
      '"My team improved faster in two months than in the entire previous season. The progression just makes sense and the girls feel it."',
    name: 'Megan R.',
    location: 'Brisbane, Australia',
  },
  {
    initials: 'SL',
    quote:
      '"I used to spend hours online searching for drills. Now I open Netball Ready 360 and everything I need is right there."',
    name: 'Sophie L.',
    location: 'Cape Town, SA',
  },
  {
    initials: 'DT',
    quote:
      '"The evaluation sheets completely changed my conversations with parents. I finally talk in numbers and they trust the process."',
    name: 'David T.',
    location: 'Auckland, NZ',
  },
  {
    initials: 'EW',
    quote:
      '"As a first-year coach I was overwhelmed. This gave me a full system from day one and my confidence on the court doubled."',
    name: 'Emma W.',
    location: 'Manchester, UK',
  },
  {
    initials: 'RB',
    quote:
      '"The Tactical Playbook Pro bailed me out in three close games this year. Having those plays ready in a time-out is a game changer."',
    name: 'Rachel B.',
    location: 'Sydney, Australia',
  },
]

export const faqs = [
  {
    question: 'How does Netball Ready 360 work?',
    answer:
      'You get instant access to all 6 volumes and 5 bonuses in digital format. Download them, open the volume you need and run the session — everything is already planned for you.',
  },
  {
    question: 'Does it work for any age group/category?',
    answer:
      'Yes. The system covers U10-U12, U13-U15 and U16-U19/Senior, with sessions and progressions adapted to every level.',
  },
  {
    question: 'Can I edit the material?',
    answer:
      'The planning sheets and templates are ready to print and use, and the editable planners let you adapt sessions to your own team.',
  },
  {
    question: 'Are the bonuses included?',
    answer:
      'Yes. All 5 strategic bonuses are included at no extra cost with your purchase today.',
  },
  {
    question: 'Is it suitable for beginner coaches?',
    answer:
      'Absolutely. Every session is explained step by step, so you can run professional training even in your first season.',
  },
  {
    question: 'Useful for school PE too?',
    answer:
      'Yes. Hundreds of PE teachers use it for classes and school teams thanks to the ready-to-use sessions and diagrams.',
  },
  {
    question: 'How long does access last?',
    answer:
      'Lifetime access. One single payment, yours forever, including future updates.',
  },
  {
    question: "What's the difference vs other materials?",
    answer:
      'This is a complete system, not a random collection of drills — full season planning, progressions by age group, tactics, physical preparation and team management in one place.',
  },
]

export const comparison = [
  { without: 'Arriving without a real plan', with: '10 min/week. Everything ready.' },
  { without: 'Searching for new drills online', with: '101 drills + 6 volumes by level' },
  { without: 'Skill levels varying wildly', with: 'Logical, measurable progression' },
  { without: 'Sessions feeling improvised', with: 'Evaluation sheets and progress tracking' },
]
